module.exports = __webpack_public_path__ + "img/Group9.b844aca2.png";